import { FormTheme } from 'api/form/types';

export const DEFAULT_CUSTOM_COLOR_CODE = '#0F62FE';
export const IMAGE_WIDTH = 100;
export const IMAGE_HEIGHT = 40;

export const FormThemesList: FormTheme[] = [
  {
    titleBarColor: '#24A148',
    headerColor: '#000000',
    backgroundColor: '#DEFBE6',
    buttonColor: '#24A148',
  },
  {
    titleBarColor: '#D12771',
    headerColor: '#000000',
    backgroundColor: '#FFF0F7',
    buttonColor: '#D12771',
  },
  {
    titleBarColor: '#A56EFF',
    headerColor: '#000000',
    backgroundColor: '#F6F2FF',
    buttonColor: '#A56EFF',
  },
  {
    titleBarColor: '#FFBF00',
    headerColor: '#000000',
    backgroundColor: '#FFFBF0',
    buttonColor: '#FFBF00',
  },
  {
    titleBarColor: '#009D9A',
    headerColor: '#000000',
    backgroundColor: '#D9FBFB',
    buttonColor: '#009D9A',
  },
  {
    titleBarColor: '#4589FF',
    headerColor: '#000000',
    backgroundColor: '#EDF5FF',
    buttonColor: '#4589FF',
  },
  {
    titleBarColor: '#878D96',
    headerColor: '#000000',
    backgroundColor: '#F2F4F8',
    buttonColor: '#878D96',
  },
  {
    titleBarColor: '#FA4D56',
    headerColor: '#000000',
    backgroundColor: '#FFF1F1',
    buttonColor: '#FA4D56',
  },
  {
    titleBarColor: '#C0C4CC',
    headerColor: '#000000',
    backgroundColor: '#F9F9FA',
    buttonColor: '#C0C4CC',
  },
];

export const DefaultHeaderImagesList = [
  {
    location:
      'https://s3.us-east-1.amazonaws.com/rocketlane-profile-pic-public/657/cbe48220-fdf3-4ed1-a10f-55cbb272b8ff/Form%20Header-06.png',
    thumbnailLocation:
      'https://s3.us-east-1.amazonaws.com/rocketlane-profile-pic-public/657/cbe48220-fdf3-4ed1-a10f-55cbb272b8ff/thumb_Form%20Header-06.png',
  },
  {
    location:
      'https://s3.us-east-1.amazonaws.com/rocketlane-profile-pic-public/657/877706e5-c4db-485f-8923-40e478806ca7/Form%20Header-09.png',
    thumbnailLocation:
      'https://s3.us-east-1.amazonaws.com/rocketlane-profile-pic-public/657/877706e5-c4db-485f-8923-40e478806ca7/thumb_Form%20Header-09.png',
  },
  {
    location:
      'https://s3.us-east-1.amazonaws.com/rocketlane-profile-pic-public/657/45b397c4-1d90-49af-884e-12f1788289d8/Form%20Header-12.png',
    thumbnailLocation:
      'https://s3.us-east-1.amazonaws.com/rocketlane-profile-pic-public/657/45b397c4-1d90-49af-884e-12f1788289d8/thumb_Form%20Header-12.png',
  },
  {
    location:
      'https://s3.us-east-1.amazonaws.com/rocketlane-profile-pic-public/657/6abdf50b-b898-4a7e-9b40-31601da7ec4d/Form%20Header-15.png',
    thumbnailLocation:
      'https://s3.us-east-1.amazonaws.com/rocketlane-profile-pic-public/657/6abdf50b-b898-4a7e-9b40-31601da7ec4d/thumb_Form%20Header-15.png',
  },
  {
    location:
      'https://s3.us-east-1.amazonaws.com/rocketlane-profile-pic-public/657/b4736f84-96b5-4ebb-89c4-63741f0dd59c/Form%20Header-18.png',
    thumbnailLocation:
      'https://s3.us-east-1.amazonaws.com/rocketlane-profile-pic-public/657/b4736f84-96b5-4ebb-89c4-63741f0dd59c/thumb_Form%20Header-18.png',
  },
  {
    location:
      'https://s3.us-east-1.amazonaws.com/rocketlane-profile-pic-public/657/3f0f94ef-2051-4214-afa9-41a901695398/Form%20Header-19.png',
    thumbnailLocation:
      'https://s3.us-east-1.amazonaws.com/rocketlane-profile-pic-public/657/3f0f94ef-2051-4214-afa9-41a901695398/thumb_Form%20Header-19.png',
  },
  {
    location:
      'https://s3.us-east-1.amazonaws.com/rocketlane-profile-pic-public/657/ac2356c1-0b41-415f-84cf-905e1341d2e8/Form%20Header-20.png',
    thumbnailLocation:
      'https://s3.us-east-1.amazonaws.com/rocketlane-profile-pic-public/657/ac2356c1-0b41-415f-84cf-905e1341d2e8/thumb_Form%20Header-20.png',
  },
  {
    location:
      'https://s3.us-east-1.amazonaws.com/rocketlane-profile-pic-public/657/fc129c98-cc72-4756-a6e0-23384e36586b/Form%20Header-21.png',
    thumbnailLocation:
      'https://s3.us-east-1.amazonaws.com/rocketlane-profile-pic-public/657/fc129c98-cc72-4756-a6e0-23384e36586b/thumb_Form%20Header-21.png',
  },
];
